import { LenderConcession } from '../../interfaces';

export const BankOfAmerica: LenderConcession = {
  lenderNameRegEx: new RegExp('BK OF AMER|BANKAMERICA|B OF A|BOFA|BOA|BKAMERIC|BANK AMERICA'),
  apr: 7.5,
  standardMinimumPercent: 1.75,
  minimumDollarAmount: 15,
};
